import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import ls from "util/secureStorage";
import constant from "config/constant";
import { wrapBaseApi } from "util/apiWrapper";

// console.log("AUTH HEADER", _headers);

// Define a service using a base URL and expected endpoints
export const swapApi = createApi({
  reducerPath: "swap",
  // refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  tagTypes: [
    "swapPairs",
    "swapRate",
    "swap",
    "swapTransactions",
    "buyCrypto",
    "sellCrypto",
    "walletBalance",
    "buyCryptoRate",
    "sellCryptoRate",
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_WALLET_API_ENDPOINT,
    prepareHeaders: (headers, _) => {
      const auth = ls.get(constant.AUTH_TOKEN_KEY);

      headers.set("Authorization", auth.token);
      headers.set("Content-Type", "application/json");
      headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getPairs: builder.query({
      query: (token) => wrapBaseApi(`/wallet/swap/pairs?token=${token}`),
      transformResponse: (res) => res?.data,
      providesTags: ["swapPairs"],
    }),
    getSwapRate: builder.query({
      query: ({ base, sub }) =>
        wrapBaseApi(`/wallet/swap/rate?base=${base}&sub=${sub}`),
      transformResponse: (res) => res?.data,
      providesTags: ["swapRate"],
    }),
    getSwapTransactions: builder.query({
      query: (queries) => wrapBaseApi(`/wallet/swap?${queries ?? "limit=10"}`),
      transformResponse: (res) => res?.data,
      providesTags: ["swapTransactions"],
    }),
    swap: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/wallet/swap`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["swap"],
      invalidatesTags: ["walletBalance"],
    }),
    buyCrypto: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/wallet/buySell/buyCrypto`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["buyCrypto"],
      invalidatesTags: ["walletBalance"],
    }),
    buyCryptoRate: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/wallet/buySell/buyCrypto/rate`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["buyCryptoRate"],
      invalidatesTags: ["walletBalance"],
    }),
    sellCrypto: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/wallet/buySell/sellCrypto`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["sellCrypto"],
      invalidatesTags: ["walletBalance"],
    }),
    sellCryptoRate: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/wallet/buySell/sellCrypto/rate`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["sellCryptoRate"],
      invalidatesTags: ["walletBalance"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPairsQuery,
  useGetSwapRateQuery,
  useGetSwapTransactionsQuery,
  useSwapMutation,
  useBuyCryptoMutation,
  useSellCryptoMutation,
  useBuyCryptoRateMutation,
  useSellCryptoRateMutation,
  endpoints,
} = swapApi;

export default swapApi;
